import { render, staticRenderFns } from "./HKLCardBody.vue?vue&type=template&id=06caf96c&scoped=true&"
var script = {}
import style0 from "./HKLCardBody.vue?vue&type=style&index=0&id=06caf96c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06caf96c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06caf96c')) {
      api.createRecord('06caf96c', component.options)
    } else {
      api.reload('06caf96c', component.options)
    }
    module.hot.accept("./HKLCardBody.vue?vue&type=template&id=06caf96c&scoped=true&", function () {
      api.rerender('06caf96c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/Card/HKLCardBody.vue"
export default component.exports